module.exports = __webpack_public_path__ + "img/no_task388.d9072c1c.png";